// searchReducer.js
import { GENERIC_SEARCH_FAILURE, GENERIC_SEARCH_REQUEST, GENERIC_SEARCH_SUCCESS } from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  results: [],
  error: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERIC_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        results: [],
        error: null,
      };
    case GENERIC_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
      };
    case GENERIC_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default searchReducer;
